import { Outlet } from "react-router-dom";

const MercadeoWraper: React.FC = () => {
    return <Outlet />;
};

export default MercadeoWraper;
